import { BaseLandscapeService } from '../../base-landscape.service';
import { ParticipantResponseDto } from '../dto/response/participant-response.dto';
import { ParticipantSaveRequestDto } from '../dto/request/participant-save-request.dto';
import { ParticipantUpdateRequestDto } from '../dto/request/participant-update-request.dto';

class ParticipantService extends BaseLandscapeService {
  public async fetchParticipantById(
    id: string
  ): Promise<ParticipantResponseDto> {
    const response = await this.get<ParticipantResponseDto>(
      `/participant/${id}`
    );
    return response.data;
  }

  public async saveParticipant(
    saveRequest: ParticipantSaveRequestDto
  ): Promise<ParticipantResponseDto> {
    const response = await this.post<ParticipantResponseDto>(
      `/participant`,
      saveRequest
    );
    return response.data;
  }

  public async updateParticipant(
    updateRequest: ParticipantUpdateRequestDto
  ): Promise<ParticipantResponseDto> {
    const response = await this.put<ParticipantResponseDto>(
      `/participant`,
      updateRequest
    );
    return response.data;
  }

  public async deleteParticipant(
    existingId: string,
    compactId: string | null = null
  ): Promise<void> {
    await this.delete<void>(`/participant/${existingId}`, {
      params: {
        compactId,
      },
    });
  }
}

const participantService = new ParticipantService();
export default participantService;
